const TAGS_SELECTOR = '.js-tags-panel';
const SINGLE_LINE_HEIGHT = 46;
const SINGLE_CLASS = 'single-line';

const tagsElement = document.querySelector<HTMLElement>(TAGS_SELECTOR);

export function initTagsPanel() {
  if (tagsElement && tagsElement.scrollHeight > SINGLE_LINE_HEIGHT) {
    tagsElement.classList.remove(SINGLE_CLASS);
  }
}
